import { styled, Switch } from "@mui/material"
import designSystemStyles from "@shared/styles/designSystemStyles"

export const QSwitch = styled(Switch)(() => ({
    padding: 8,
    "&.Mui-checked": {
        "& + .MuiSwitch-track": {
            backgroundColor: designSystemStyles.colorSwitchTrackOn,
            border: `5px solid ${designSystemStyles.colorSwitchTrackOn}`,
            opacity: 1,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 1,
        },
    },
    "& .MuiSwitch-track": {
        borderRadius: 22 / 2,
        opacity: 1,
        backgroundColor: designSystemStyles.colorSwitchTrackOff,
        "&::before, &::after": {
            content: '""',
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            width: 16,
            height: 16,
        },
    },
    "& .MuiSwitch-thumb": {
        boxShadow: "none",
        width: 16,
        height: 16,
        margin: 2,
        backgroundColor: designSystemStyles.colorSwitchThumb,
    },
    "& .MuiSwitch-switchBase": {
        "&.Mui-checked": {
            color: designSystemStyles.colorSwitchTrackOn,
            "& + .MuiSwitch-track": {
                backgroundColor: designSystemStyles.colorSwitchTrackOn,
                opacity: 1,
            },
        },
    },
}))
